import React from 'react';
import { useSessionTimeout } from '../context/AlertSessionTimeout';

export const DebugSessionTimeout = () => {
  const { expiredTime } = useSessionTimeout();
  if (process.env.REACT_APP_ENV === 'production') return null;

  return <div style={{ color: '#f7f7f7' }}>{expiredTime}</div>;
};
